/**
 * `?tab=code&path=brain/outputs/report.html` (the old `?view=files&path=…` too): the file Code at Home should open (a
 * link from the chat).
 */
export function filesPathFromSearch(search) {
  const params = new URLSearchParams(search || '');
  const tab = params.get('tab');
  const inCode = tab === 'code' || (params.get('view') === 'files' && (!tab || tab === 'code'));
  const path = inCode ? params.get('path') : null;
  return path && !path.startsWith('/') && !path.split('/').includes('..') ? path : null;
}

/** `?tab=code&path=…&line=42` (or the old `?view=files&…`): the line to show in that file (a search result), or null. */
export function filesLineFromSearch(search) {
  if (!filesPathFromSearch(search)) { return null; }
  const line = Number(new URLSearchParams(search || '').get('line'));
  return Number.isInteger(line) && line > 0 ? line : null;
}

/** The project-relative path of a file picked in the Files view, whose tree may be rooted at a folder (`focus`) instead of the project. */
export function fullFilesPath(focus, filePath) {
  const clean = String(filePath || '').replace(/^\/+/, '');
  const root = !focus || focus === '.' ? '' : String(focus).replace(/\/+$/, '');
  return root ? `${root}/${clean}` : clean;
}

/** The reverse: a project-relative path as the tree rooted at `focus` knows it, or `null` when the file is outside that folder. */
export function pathWithinFocus(focus, fullPath) {
  if (!fullPath) { return null; }
  const root = !focus || focus === '.' ? '' : String(focus).replace(/\/+$/, '');
  if (!root) { return fullPath; }
  return fullPath.startsWith(`${root}/`) ? fullPath.slice(root.length + 1) : null;
}

/** `/brain?path=memory/notes.md&line=12` (a search result): the Brain file to open and the line, or nulls. */
export function brainFileFromSearch(search) {
  const params = new URLSearchParams(search || '');
  const path = params.get('path');
  const line = Number(params.get('line'));
  const valid = Boolean(path) && !path.startsWith('/') && !path.split('/').includes('..');
  return { path: valid ? path : null, line: valid && Number.isInteger(line) && line > 0 ? line : null };
}

/** A safe project-relative file path (no leading `/`, no `..`), else null. */
export const cleanFilePath = (path) => (typeof path === 'string' && path && !path.startsWith('/') && !path.split('/').includes('..') ? path : null);

/**
 * The service folder a file belongs to (`services/<name>`, from `services/<name>/…`), or null for a file outside every
 * service (the Brain, inputs, results, screenshots, `.flow/`, the root's README): those open in the Files tab, service
 * code opens in Code on its service.
 */
export function serviceOfFile(path) {
  const match = /^services\/([^/]+)\/./.exec(cleanFilePath(path) || '');
  return match ? `services/${match[1]}` : null;
}
